import { useAuthState } from '@/contexts/AuthProvider';
import { MAX_VOTE_COUNT_PER_DAY } from '@diritto/common/contest/constants';
import { configure } from 'utils/configure';

const BASE_URL = `${configure.staticPrefix}/images/contests/4/vote`;

const STAMP_SIZES: string[] = [
  'size-[57px] -translate-y-[6px] -translate-x-[1px]',
  'size-[40px] -translate-y-[8px]',
  'size-[57px] -translate-y-[4px] translate-x-[5px]',
  'w-[120px] h-[50px] -translate-y-[6px] -translate-x-[2px]',
  'size-[57px] -translate-y-[2px] translate-x-[3px]',
  'w-[120px] h-[40px] -translate-y-[3px] translate-x-[5px]',
  'w-[70px] h-[30px]',
] as const;

export const VoteStampSheet = ({
  date,
  index,
  today,
  votedCount,
}: {
  date: string;
  index: number;
  today: string;
  votedCount: number;
}) => {
  const { isLoggedIn } = useAuthState();

  if (index >= STAMP_SIZES.length) {
    return null;
  }

  const isPast = date < today;
  const isToday = date === today;
  const sizeClass = STAMP_SIZES[index] || 'size-[57px]';

  return (
    <div className={`relative flex items-center justify-center w-[103px] h-[103px]`}>
      {(isPast || isToday) && isLoggedIn ? (
        <span className="font-bold text-[20px] text-[#FFDB59] -translate-y-[8px]">
          {votedCount}/{MAX_VOTE_COUNT_PER_DAY}
        </span>
      ) : (
        <img src={`${BASE_URL}/stamp-sheet/${index + 1}.webp`} alt={date} className={`${sizeClass} object-contain`} />
      )}

      {isLoggedIn && <VoteStamp votedCount={votedCount} isPast={isPast} />}
    </div>
  );
};

const VoteStamp = ({ votedCount, isPast }: { votedCount: number; isPast: boolean }) => {
  const isVoteCompleted = votedCount >= MAX_VOTE_COUNT_PER_DAY;

  if (isVoteCompleted) {
    return <StampImage type="success" />;
  }
  if (isPast) {
    return <StampImage type="fail" />;
  }
  return null;
};

const StampImage = ({ type }: { type: 'success' | 'fail' }) => (
  <div className="absolute flex justify-center items-center">
    <img src={`${BASE_URL}/stamp/${type}.webp`} alt={type} className="w-[57px] h-[57px] -rotate-[32deg]" />
  </div>
);
